import { ReviewProps } from '@/interfaces/models/review';
import { ClientProps } from '@/interfaces/models/client';
import { OrderProductProps } from '@/interfaces/models/orderProduct';
import { OrderStaffProps } from '@/interfaces/models/orderStaff';

export interface TakeAwayProps {
  client: null | ClientProps;
  comment: null | string;
  createdAt: number;
  cookingAt: number | null;
  datetime: number;
  discount: number | null;
  discountAmount: number;
  doneAt: number | null;
  id: string;
  isCancel: boolean;
  isCooking: boolean;
  isDone: boolean;
  isPrinted: boolean;
  paidOnline: boolean;
  isRefund: boolean;
  isSave: boolean;
  isWidget: boolean;
  products: OrderProductProps[];
  orderNumber: string;
  orderNumberInQueue: string;
  orderType: OrderTypes;
  placeId: string | undefined;
  placeName: string | undefined;
  printError: string;
  review: null | ReviewProps;
  staff: null | OrderStaffProps;
  systemOrderNumber: number;
  totalSpent: number;
  typeOfPayment: null | TypeOfPayment;
}

export type TypeOfPayment = {
  codeInPos: number;
  id: number;
  isFiscal: boolean;
  name: string;
};

export enum OrderTypes {
  Reservation = 0,
  TakeAway = 1,
  Terminal = 2,
  Delivery = 3,
  OnlineReservation = 4,
  OnlineTakeAway = 5,
  OnlineDelivery = 6,
}
